import { ContainerModule } from 'inversify';
import { CommandHistory } from '../services/CommandHistory';
import { TYPES } from './types';
import { CoreModule } from '../module/Core.module.ts';
import { HotKeysService } from '../services/HotKeys.service';
import { CommandProcessor } from '../services/CommandProcessor';
import { ObservabilityLoggerService } from '@/app.obresvability/loggerService/observabilityLogger.service.ts';

export const coreModule = new ContainerModule((bind) => {
  bind<CommandHistory>(TYPES.CommandHistory).to(CommandHistory).inSingletonScope();
  bind<CoreModule>(TYPES.CoreModule).to(CoreModule).inSingletonScope();
  bind<HotKeysService>(TYPES.HotKeysService).to(HotKeysService).inSingletonScope();
  bind<CommandProcessor>(TYPES.CommandProcessor).to(CommandProcessor).inSingletonScope();
  bind<ObservabilityLoggerService>(TYPES.ObservabilityLoggerService).to(ObservabilityLoggerService).inSingletonScope();
});
